<template>
    <div>
        <nav aria-label="breadcrumb" v-if="session">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="breadcrumbLink">Sessions ({{ session.difficultyLevel }} - {{ session.difficulty }})</router-link></li>
                <li class="breadcrumb-item active">Session {{ session.dataId || 'TUTORIAL' }} <span v-if="sessionLineDisplay">({{ sessionLineDisplay }})</span></li>
            </ol>
        </nav>

        <h1>Session</h1>

        <div v-if="loading">
            Loading session..
        </div>
        <div v-else>
            <h2>Scenarios</h2>

            <table class="table table-bordered table-striped" v-if="session">
                <thead>
                <tr>
                    <th>Index</th>
                    <th>State</th>
                    <th>Crime</th>
                    <th>People count</th>
                    <th>Indicator count</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="scenario in session.scenarios">
                    <td>{{ scenario.index + 1 }}</td>
                    <td><font-awesome-icon :icon="getStateIcon(scenario)" /> {{ getState(scenario) }}</td>
                    <td class="crime" :class="getCrimeClass(scenario)">{{ getCrime(scenario) }}</td>
                    <td>{{ scenario.peopleCount || 0 }}</td>
                    <td>{{ scenario.indicatorCount || 0 }}</td>
                    <td>
                        <router-link class="btn btn-primary btn-sm" :to="'/admin/scenarios/update/' + scenario.id">Edit</router-link>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'sessions-update',
        data() {
            return {
                loading: true,

                session: null
            }
        },
        mounted() {
            this.load();
        },
        methods: {
            load() {
                this.loading = true;

                this.$apiClient.getSession(this.sessionId).then((session) => {
                    this.loading = false;

                    this.session = session;

                    console.log(session);
                });
            },
            getCrimeClass(scenario) {
                if (!scenario.hasCrime) {
                    return 'crime-no-crime';
                }

                if (!scenario.crime) {
                    return 'crime-no-crime-selected';
                }

                return 'crime-has-crime';
            },
            getCrime(scenario) {
                if (!scenario.hasCrime) {
                    return '(no crime)';
                }

                if (!scenario.crime) {
                    return '(no crime selected)';
                }

                return scenario.crime.crime;
            },
            getState(scenario) {
                if (scenario.draftDetails) {
                    return 'Draft';
                }

                return 'Published';
            },
            getStateIcon(scenario) {
                if (scenario.draftDetails) {
                    return 'edit';
                }

                return 'check';
            }
        },
        computed: {
            sessionId() {
                return this.$route.params.id;
            },
            sessionLineDisplay() {
                if (!this.session) {
                    return;
                }

                if (!this.session.line) {
                    return;
                }

                if (this.session.line === 'first') {
                    return 'FLC';
                } else if (this.session.line === 'second') {
                    return 'SLC';
                }

                return;
            },
            breadcrumbLink() {
                if (!this.session) {
                    return;
                }

                return {
                    path: '/admin/sessions',
                    query: {
                        difficultyLevel: this.session.difficultyLevel,
                        difficulty: this.session.difficulty,
                    }
                }
            }
        },
        watch: {
            sessionId() {
                console.log('xxx');
                this.load();
            }
        }
    }
</script>

<style scoped lang="scss">
    .crime {
        &.crime-no-crime {
            background: #ffbbbb;
            color: #bb0000;
        }

        &.crime-no-crime-selected {

        }

        &.crime-has-crime {

        }
    }
</style>
